/**
 * レスポンシブデザインのブレークポイント定数
 * SCSS の style-common.scss と値を一致させる必要があります
 */

// SCSS で定義されているブレークポイント値
export const BREAKPOINTS = {
  XS: 480, // Extra small screen (smartphone)
  SM: 768, // Small screen (tablet)
  MD: 992, // Medium screen (desktop)
  LG: 1200, // Large screen (wide desktop)
} as const;

// スマートフォン判定のブレークポイント（SCSS の @include mq(sp) と同値）
export const MOBILE_BREAKPOINT = BREAKPOINTS.SM - 1; // 767px

/**
 * 現在の画面幅がモバイル（スマートフォン）かどうかを判定
 * @param width 画面幅（デフォルトは window.innerWidth）
 * @returns モバイルの場合 true
 */
export const isMobile = (width: number = window.innerWidth): boolean => width <= MOBILE_BREAKPOINT;

/**
 * 主な入力がタッチの端末（スマホ・タブレット）かどうかを判定
 * 幅に関係なく、iOSネイティブの選択メニューと競合する環境を検出するために使う
 */
export const isTouchPrimary = (): boolean => window.matchMedia("(hover: none) and (pointer: coarse)").matches;

/**
 * 下部の引用バーで引用操作を提供すべきかどうかを判定
 * SP幅、またはタッチが主な入力の端末（タブレット等）が対象
 */
export const usesQuoteBar = (): boolean => isMobile() || isTouchPrimary();

/**
 * デバイスタイプを判定する関数群
 */
export const deviceDetectors = {
  isXS: (width: number = window.innerWidth) => width < BREAKPOINTS.XS,
  isSM: (width: number = window.innerWidth) => width >= BREAKPOINTS.XS && width < BREAKPOINTS.SM,
  isMD: (width: number = window.innerWidth) => width >= BREAKPOINTS.SM && width < BREAKPOINTS.MD,
  isLG: (width: number = window.innerWidth) => width >= BREAKPOINTS.MD && width < BREAKPOINTS.LG,
  isXL: (width: number = window.innerWidth) => width >= BREAKPOINTS.LG,

  // SCSS の mq(sp) と mq(pc) と同等
  isMobile: (width: number = window.innerWidth) => width <= MOBILE_BREAKPOINT,
  isPC: (width: number = window.innerWidth) => width >= BREAKPOINTS.SM,
} as const;
